<template>
    <div class="storeData">
        <div class="storeData_pane">
            <el-tabs tab-position="top" type="card">
                <el-tab-pane label="全部">
                    <realTimeAll ref="realTimeAllRef" :chartsWidth="chartsWidth"></realTimeAll>
                </el-tab-pane>
                <el-tab-pane label="我要打印">
                    <realTimePrint ref="realTimePrintRef" :chartsWidth="chartsWidth"></realTimePrint>
                </el-tab-pane>
                <el-tab-pane label="3D商城">
                    <realTimeShop ref="realTimeShopRef" :chartsWidth="chartsWidth"></realTimeShop>
                </el-tab-pane>
                <el-tab-pane label="3D模型库">
                    <realTimeModel ref="realTimeModelRef" :chartsWidth="chartsWidth"></realTimeModel>
                </el-tab-pane>
                <el-tab-pane label="设计市场">
                    <realTimeDesign ref="realTimeDesignRef" :chartsWidth="chartsWidth"></realTimeDesign>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import {getRealTimeStatisticData} from "../../utils/interface";

import realTimeAll from "./realTimeAll";
import realTimePrint from "./realTimePrint";
import realTimeDesign from "./realTimeDesign";
import realTimeShop from "./realTimeShop";
import realTimeModel from "./realTimeModel";

export default {
        name: "realTimeStatistic",
        components: {
            //全部
            realTimeAll,
            //我要打印
            realTimePrint,
            //设计市场
            realTimeDesign,
            //3D商城
            realTimeShop,
            //模型库
            realTimeModel,
        },
        data() {
            return {
                tabPosition: "",
                dateDay: "",
                chartsWidth: "",
                nowDate: "",
                startTime: "",
                endTime: "",
                timeType:"nowDay",
                loading: false,
            };
        },
        created() {
            this.chartsWidth = window.innerWidth - 220 + "px";
        },
        mounted() {
            this.init()
        },
        methods: {
            init(){
                this.status = null
                this.goodsName = null
                // this.pageNo = 1
                this.getList();
            },
            getList(){
                this.loading = true
                getRealTimeStatisticData('').then(res=>{
                    if(res.success){
                        this.$refs.realTimeAllRef.init(res.data);
                    }
                })
                getRealTimeStatisticData('PRINT').then((res)=>{
                    if(res.success){
                        this.$refs.realTimePrintRef.init(res.data);
                    }
                    this.loading = false
                });
                getRealTimeStatisticData('DESIGN').then((res)=>{
                    if(res.success){
                        this.$refs.realTimeDesignRef.init(res.data);
                    }
                    this.loading = false
                });
                getRealTimeStatisticData('SHOP').then((res)=>{
                    if(res.success){
                        this.$refs.realTimeShopRef.init(res.data);
                    }
                    this.loading = false
                });
                getRealTimeStatisticData('MODEL').then((res)=>{
                    if(res.success){
                        this.$refs.realTimeModelRef.init(res.data);
                    }
                    this.loading = false
                });
            }
        },
    };
</script>
<style scoped lang="less">
    .storeData {
        background-color: #ffffff;
        padding: 20px;
        margin: 0 20px;

        .storeData_nap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
        }
    }

    //隐藏的CSS代码
    /*按钮日期选择器隐藏ipnut*/
    .hide_input {
        position: relative !important;
    }

    //修改控件自带的css
    .hide_input /deep/ .el-date-editor {
        position: absolute; //绝对定位
        top: 0;
        left: 0;
        opacity: 0; //设置完全透明
    }

    .hide_input /deep/ .el-input__prefix {
        left: 0;
        width: 55px;
    }
</style>



// WEBPACK FOOTER //
// src/views/statistic/realTimeStatistic.vue